import { ArrowProps } from "../../../types"

export const Arrow = (props: ArrowProps) => {
  const rotateString = props.rotate ? `rotate-${props.rotate}` : ""
  return (
    <svg
      className={`w-6 h-6 shrink-0 text-gray-500 ${rotateString}`}
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
    </svg>
  )
}

export const LinkIcon = () => {
  return (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      width="24"
      height="24"
      className="text-gray-400 h-[33px] w-[33px] m-auto"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
        d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  )
}

export const ChevronUpDownIcon = () => {
  return (
    <svg className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path
        fillRule="evenodd"
        d="M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75
          0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908
          2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export const NotificationIcon = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke={color}
      className="w-6 h-6"
      style={{ paddingTop: "2px" }}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6
                  6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714
                  0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"
      />
    </svg>
  )
}

export const NotificationIconSolid = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      className="w-6 h-6"
      style={{ paddingTop: "2px" }}
    >
      <path
        fillRule="evenodd"
        d="M5.25 9a6.75 6.75 0 0113.5 0v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 01-.297 1.206c-1.544.57-3.16.99-4.831 1.243a3.75 3.75 0 11-7.48 0 24.585 24.585 0 01-4.831-1.244.75.75 0 01-.298-1.205A8.217 8.217 0 005.25 9.75V9zm4.502 8.9a2.25 2.25 0 104.496 0 25.057 25.057 0 01-4.496 0z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export const CloseNotificationIcon = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke={color}
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  )
}

export const PieChartLoading = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="300px"
      height="300px"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <circle cx="50" cy="50" r="0" fill="none" stroke="#e4dfff" strokeWidth="2">
        <animate
          attributeName="r"
          repeatCount="indefinite"
          dur="2.6315789473684212s"
          values="0;40"
          keyTimes="0;1"
          keySplines="0 0.2 0.8 1"
          calcMode="spline"
          begin="0s"
        ></animate>
        <animate
          attributeName="opacity"
          repeatCount="indefinite"
          dur="2.6315789473684212s"
          values="1;0"
          keyTimes="0;1"
          keySplines="0.2 0 0.8 1"
          calcMode="spline"
          begin="0s"
        ></animate>
      </circle>
      <circle cx="50" cy="50" r="0" fill="none" stroke="#f0fed8" strokeWidth="2">
        <animate
          attributeName="r"
          repeatCount="indefinite"
          dur="2.6315789473684212s"
          values="0;40"
          keyTimes="0;1"
          keySplines="0 0.2 0.8 1"
          calcMode="spline"
          begin="-1.3157894736842106s"
        ></animate>
        <animate
          attributeName="opacity"
          repeatCount="indefinite"
          dur="2.6315789473684212s"
          values="1;0"
          keyTimes="0;1"
          keySplines="0.2 0 0.8 1"
          calcMode="spline"
          begin="-1.3157894736842106s"
        ></animate>
      </circle>
    </svg>
  )
}

export const PieChartLoading2 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="300px"
      height="300px"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <path fill="none" d="M50 30A20 20 0 0 1 50 70A20 20 0 0 1 50 30" stroke="#f0fed8" strokeWidth="40">
        <animate
          attributeName="stroke-dasharray"
          repeatCount="indefinite"
          dur="1.923076923076923"
          values="0 0 0 126;0 0 126 126;0 126 126 126"
          keyTimes="0;0.5;1"
          keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
          calcMode="spline"
        ></animate>
        <animate
          attributeName="stroke"
          values="#f0fed8;#e4dfff;#fff1e9;#fae1ee;#f0fed8"
          keyTimes="0;0.25;0.5;0.75;1"
          dur="7.692307692307692s"
          calcMode="discrete"
          repeatCount="indefinite"
        ></animate>
      </path>
    </svg>
  )
}

export const CurrencyIcon = (props: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 64 64"
      id="currency-exchange"
      className={props.className}
    >
      <path
        d="M32 28.7a14.35 14.35 0 1 1 14.35-14.35A14.37 14.37 0 0 1 32 28.7ZM32 1a13.37 13.37 0 1 0 13.36 13.35A13.38 13.38 0 0 0 32 1Z"></path>
      <path
        d="M36.26 19.72a3 3 0 0 1 0 .46 1.53 1.53 0 0 1-.08.31.55.55 0 0 1-.12.16.3.3 0 0 1-.16.05h-7.77a.3.3 0 0 1-.16-.05.55.55 0 0 1-.12-.16 1.53 1.53 0 0 1-.08-.31 3 3 0 0 1 0-.46 3.18 3.18 0 0 1 0-.47 1.11 1.11 0 0 1 .07-.3.36.36 0 0 1 .13-.16.24.24 0 0 1 .16-.05h1V15.3h-1a.42.42 0 0 1-.16 0 .44.44 0 0 1-.12-.16 1.3 1.3 0 0 1-.08-.29 3.09 3.09 0 0 1 0-.47 2.81 2.81 0 0 1 0-.45 1.11 1.11 0 0 1 .07-.3.39.39 0 0 1 .13-.15.24.24 0 0 1 .16 0h1v-.98a7.1 7.1 0 0 1 .26-2 3.8 3.8 0 0 1 .76-1.41 3 3 0 0 1 1.25-.81A5.3 5.3 0 0 1 33.13 8a5.46 5.46 0 0 1 .82.06 4.75 4.75 0 0 1 .72.17 4.58 4.58 0 0 1 .59.27 1.82 1.82 0 0 1 .39.27 1.3 1.3 0 0 1 .17.21.76.76 0 0 1 .08.2 1.21 1.21 0 0 1 0 .3v.87a.92.92 0 0 1-.08.3.41.41 0 0 1-.11.16.3.3 0 0 1-.15 0 .51.51 0 0 1-.3-.14 3.53 3.53 0 0 0-.43-.29 3.35 3.35 0 0 0-.6-.3 2.3 2.3 0 0 0-.83-.13 1.85 1.85 0 0 0-.82.16 1.3 1.3 0 0 0-.55.46 2 2 0 0 0-.31.75 4.61 4.61 0 0 0-.1 1v1h2.6a.24.24 0 0 1 .16 0 .31.31 0 0 1 .12.15 1.6 1.6 0 0 1 .08.3 2.81 2.81 0 0 1 0 .45 3.09 3.09 0 0 1 0 .47.9.9 0 0 1-.09.29.3.3 0 0 1-.12.16.33.33 0 0 1-.15 0h-2.6v3.44h4.21a.24.24 0 0 1 .16.05.3.3 0 0 1 .12.16 1.6 1.6 0 0 1 .08.3 3.18 3.18 0 0 1 .07.63zM14.94 62.28a14.35 14.35 0 1 1 14.35-14.35 14.36 14.36 0 0 1-14.35 14.35zm0-27.71A13.37 13.37 0 1 0 28.3 47.93a13.39 13.39 0 0 0-13.36-13.36zm34.12 27.71a14.35 14.35 0 1 1 14.35-14.35 14.36 14.36 0 0 1-14.35 14.35zm0-27.71a13.37 13.37 0 1 0 13.37 13.36 13.38 13.38 0 0 0-13.37-13.36z"></path>
      <path
        d="M18.86 50.16a3.46 3.46 0 0 1-.27 1.4 3.24 3.24 0 0 1-.79 1.08 3.81 3.81 0 0 1-1.21.72 6 6 0 0 1-1.59.34l-.19 1.93a.24.24 0 0 1-.15.22 1 1 0 0 1-.24.06h-.84a1 1 0 0 1-.27-.08.24.24 0 0 1-.13-.13.28.28 0 0 1 0-.18l.19-1.84a5.25 5.25 0 0 1-.73-.14 4.15 4.15 0 0 1-.62-.19 4.79 4.79 0 0 1-.49-.21 1.29 1.29 0 0 1-.3-.21.6.6 0 0 1-.15-.31A2.83 2.83 0 0 1 11 52v-.5a1 1 0 0 1 .06-.31.31.31 0 0 1 .12-.15.24.24 0 0 1 .15 0 .76.76 0 0 1 .35.13 6 6 0 0 0 .58.3 5.18 5.18 0 0 0 .85.3 4.55 4.55 0 0 0 1.18.14 2.52 2.52 0 0 0 1.57-.4 1.25 1.25 0 0 0 .51-1 1.08 1.08 0 0 0-.22-.71 2 2 0 0 0-.59-.5 6.43 6.43 0 0 0-.83-.38l-1-.35c-.32-.13-.64-.28-1-.44a3.43 3.43 0 0 1-.83-.63 2.63 2.63 0 0 1-.6-.9 3.4 3.4 0 0 1-.22-1.27 3.26 3.26 0 0 1 .35-1.33 2.9 2.9 0 0 1 .65-1 3.16 3.16 0 0 1 1-.67 5.2 5.2 0 0 1 1.45-.33l.18-1.81a.28.28 0 0 1 0-.13.35.35 0 0 1 .11-.09l.23-.06h.85a1.07 1.07 0 0 1 .28.08.24.24 0 0 1 .13.13.57.57 0 0 1 0 .18l-.18 1.71c.17 0 .34.06.53.1a3.55 3.55 0 0 1 .52.15 3.83 3.83 0 0 1 .45.18 1 1 0 0 1 .27.17.79.79 0 0 1 .12.15.53.53 0 0 1 .06.19 1.12 1.12 0 0 1 0 .27V44.05a1.43 1.43 0 0 1-.05.28.23.23 0 0 1-.08.12.2.2 0 0 1-.11 0 .92.92 0 0 1-.34-.11c-.15-.08-.34-.17-.56-.26a6.78 6.78 0 0 0-.76-.25 3.45 3.45 0 0 0-.94-.12 3.09 3.09 0 0 0-.8.09 1.48 1.48 0 0 0-.55.26.88.88 0 0 0-.3.39 1.13 1.13 0 0 0-.1.49 1.16 1.16 0 0 0 .22.72 2 2 0 0 0 .6.49 5.57 5.57 0 0 0 .85.38l1 .36a10.45 10.45 0 0 1 1 .44A3.75 3.75 0 0 1 18 48a2.79 2.79 0 0 1 .6.89 3.14 3.14 0 0 1 .26 1.27zm34.96 2.45a2.56 2.56 0 0 1-.07.69 1.21 1.21 0 0 1-.22.39 2.09 2.09 0 0 1-.4.28 4 4 0 0 1-.64.26 5.62 5.62 0 0 1-.87.2 5.94 5.94 0 0 1-1.08.08 6.18 6.18 0 0 1-2-.28 4.19 4.19 0 0 1-1.47-.82 4.09 4.09 0 0 1-1-1.32 6.75 6.75 0 0 1-.55-1.78h-.94c-.1 0-.18-.07-.24-.19a1.69 1.69 0 0 1-.09-.65 3.79 3.79 0 0 1 0-.38.73.73 0 0 1 0-.25.3.3 0 0 1 .08-.14.22.22 0 0 1 .14-.05h.87V47.26h-.87c-.1 0-.17-.06-.22-.18a1.89 1.89 0 0 1-.07-.64 2.25 2.25 0 0 1 0-.4 1.31 1.31 0 0 1 .06-.25.36.36 0 0 1 .11-.13.2.2 0 0 1 .13 0h1a7 7 0 0 1 .58-1.73 4.56 4.56 0 0 1 1-1.35 4.13 4.13 0 0 1 1.43-.87 5.45 5.45 0 0 1 1.94-.31 6.52 6.52 0 0 1 1.86.26 5.29 5.29 0 0 1 .63.24l.36.21a.56.56 0 0 1 .16.19 1 1 0 0 1 .08.23c0 .09 0 .21.05.35s0 .31 0 .52v.43a1.31 1.31 0 0 1-.07.27.23.23 0 0 1-.11.14.23.23 0 0 1-.14 0 .66.66 0 0 1-.25-.14c-.14-.09-.31-.19-.52-.3a5.45 5.45 0 0 0-.74-.29 3.46 3.46 0 0 0-1-.13 2.76 2.76 0 0 0-1 .15 1.91 1.91 0 0 0-.72.45 2.18 2.18 0 0 0-.48.7 4.15 4.15 0 0 0-.29.94H51a.22.22 0 0 1 .13 0 .27.27 0 0 1 .1.13 1.26 1.26 0 0 1 .07.25v.4a1.57 1.57 0 0 1-.09.64.25.25 0 0 1-.23.18h-2.9V48.61H51a.24.24 0 0 1 .13.05.26.26 0 0 1 .1.14 1 1 0 0 1 .07.25 3.79 3.79 0 0 1 0 .38 1.69 1.69 0 0 1-.09.65.26.26 0 0 1-.23.19h-2.71a3.15 3.15 0 0 0 .27.9 2 2 0 0 0 .49.67 2.09 2.09 0 0 0 .76.43 3.43 3.43 0 0 0 1.07.14 3.39 3.39 0 0 0 1-.13 4.34 4.34 0 0 0 .74-.31c.21-.11.39-.21.53-.3a.63.63 0 0 1 .35-.14.23.23 0 0 1 .14 0 .31.31 0 0 1 .11.15 1.14 1.14 0 0 1 .06.32 4 4 0 0 1 .03.61zM9.14 31.32H9a.5.5 0 0 1-.37-.59 23.85 23.85 0 0 1 5.84-11 .5.5 0 1 1 .72.68 22.83 22.83 0 0 0-5.6 10.52.48.48 0 0 1-.45.39zm45.72 0a.48.48 0 0 1-.48-.38 22.72 22.72 0 0 0-5.6-10.52.49.49 0 1 1 .71-.68 23.81 23.81 0 0 1 5.85 11 .5.5 0 0 1-.38.59zM32 64a23 23 0 0 1-3.13-.21 23.35 23.35 0 0 1-3.52-.73.49.49 0 0 1 .28-.94 22.34 22.34 0 0 0 3.37.69 22.73 22.73 0 0 0 6 0 21.3 21.3 0 0 0 3.38-.71.49.49 0 0 1 .27 1 24.37 24.37 0 0 1-3.52.74A25.55 25.55 0 0 1 32 64z"></path>
    </svg>
  )
}

export const SumIcon = (props: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="1"
      clipRule="evenodd"
      viewBox="0 0 32 33"
      id="sigma"
      className={props.className}
    >
      <path
        d="M4,2c-1.656,0 -3,1.344 -3,3l0,24c0,1.656 1.344,3 3,3l24,0c1.656,0 3,-1.344 3,-3l0,-24c0,-1.656 -1.344,-3 -3,-3l-24,0Zm0,2l24,0c0.552,0 1,0.448 1,1l0,24c0,0.552 -0.448,1 -1,1l-24,0c-0.552,0 -1,-0.448 -1,-1l0,-24c0,-0.552 0.448,-1 1,-1Zm6,3c-0.354,0 -0.681,0.186 -0.861,0.492c-0.18,0.305 -0.184,0.684 -0.012,0.994l4.728,8.514l-4.728,8.514c-0.172,0.31 -0.168,0.689 0.012,0.994c0.18,0.306 0.507,0.492 0.861,0.492l12,0c0.552,0 1,-0.448 1,-1l0,-2c0,-0.552 -0.448,-1 -1,-1c-0.552,0 -1,0.448 -1,1l0,1l-9.301,0l4.174,-7.514c0.168,-0.302 0.168,-0.67 0,-0.972l-4.174,-7.514l9.301,0l0,1c0,0.552 0.448,1 1,1c0.552,0 1,-0.448 1,-1l0,-2c0,-0.552 -0.448,-1 -1,-1l-12,0Z"></path>
    </svg>
  )
}

export const WarningIcon = (props: { className?: string; color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={props.color ? props.color : "currentColor"}
      className={props.className}
    >
      <path
        fillRule="evenodd"
        d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export const RefreshIcon = (props: { className?: string; color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      className={props.className}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
      />
    </svg>
  )
}

export const InfoIcon = (props: { className?: string; color?: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 50 50" className={props.className}>
      <path
        d="M 25 2 C 12.309295 2 2 12.309295 2 25 C 2 37.690705 12.309295 48 25 48 C 37.690705 48 48 37.690705 48 25 C 48 12.309295 37.690705 2 25 2 z M 25 4 C 36.609824 4 46 13.390176 46 25 C 46 36.609824 36.609824 46 25 46 C 13.390176 46 4 36.609824 4 25 C 4 13.390176 13.390176 4 25 4 z M 25 11 A 3 3 0 0 0 22 14 A 3 3 0 0 0 25 17 A 3 3 0 0 0 28 14 A 3 3 0 0 0 25 11 z M 21 21 L 21 23 L 22 23 L 23 23 L 23 36 L 22 36 L 21 36 L 21 38 L 22 38 L 23 38 L 27 38 L 28 38 L 29 38 L 29 36 L 28 36 L 27 36 L 27 21 L 26 21 L 22 21 L 21 21 z"></path>
    </svg>
  )
}
